

export const IMAGE_FOLDER = `${process.env.PUBLIC_URL}/images`;
export const DISABLE_AUTHENTICATION = process.env.REACT_APP_DISABLE_AUTHENTICATION === 'true';


// // Your web app's Firebase configuration
// const firebaseConfig = {
//     apiKey: "AIzaSyCDsED1esBBDFgjvMqfM8ghi0fY596k4rY",
//     authDomain: "sagami-bombers.firebaseapp.com",
//     projectId: "sagami-bombers",
//     storageBucket: "sagami-bombers.appspot.com",
//     messagingSenderId: "528221557705",
//     appId: "1:528221557705:web:63ec8d9716ba3021e74e18"
//   };
